import React from 'react'
  import { MDXTag } from '@mdx-js/tag'


  import DefaultLayout from "/opt/build/repo/src/components/layout.js";
import SEO from "../components/seo";
const layoutProps = {};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props);
    this.layout = DefaultLayout;
  }

  render() {
    const {
      components,
      ...props
    } = this.props;
    return <MDXTag name="wrapper" Layout={this.layout} layoutProps={Object.assign({}, layoutProps, props)} components={components}>


      <SEO title='Information Portal' />
      <section>
        <MDXTag name="h2" components={components}>{`Information Portal`}</MDXTag>
        <MDXTag name="p" components={components}>{`Here you will find links to information about this hackathon.
We try to put as much of these on public as possible.`}</MDXTag>
        <MDXTag name="ul" components={components}>
          <MDXTag name="li" components={components} parentName="ul">
            <MDXTag name="p" components={components} parentName="li"><MDXTag name="a" components={components} parentName="p" props={{
                "href": "/"
              }}><MDXTag name="strong" components={components} parentName="a">{`Website`}</MDXTag></MDXTag>{` (`}<MDXTag name="a" components={components} parentName="p" props={{
                "href": "https://gitlab.com/StupidHackTH/3"
              }}>{`source code`}</MDXTag>{`)`}</MDXTag>
          </MDXTag>
          <MDXTag name="li" components={components} parentName="ul">
            <MDXTag name="p" components={components} parentName="li"><MDXTag name="a" components={components} parentName="p" props={{
                "href": "https://gitlab.com/StupidHackTH/3/issues"
              }}><MDXTag name="strong" components={components} parentName="a">{`Issue tracker`}</MDXTag></MDXTag></MDXTag>
          </MDXTag>
          <MDXTag name="li" components={components} parentName="ul">
            <MDXTag name="p" components={components} parentName="li"><MDXTag name="a" components={components} parentName="p" props={{
                "href": "https://www.notion.so/stupidhackth3/Stupid-Balance-Tracking-Sheet-f33d403a1db94bd8945525ccf452c2e0"
              }}><MDXTag name="strong" components={components} parentName="a">{`Stupid Balance Tracking Sheet`}</MDXTag></MDXTag>{`
contains all financial information such as income and expense.`}</MDXTag>
          </MDXTag>
        </MDXTag>
        <MDXTag name="p" components={components}>{`Information about past events (StupidHackTH2)`}</MDXTag>
        <MDXTag name="ul" components={components}>
          <MDXTag name="li" components={components} parentName="ul">
            <MDXTag name="p" components={components} parentName="li"><MDXTag name="a" components={components} parentName="p" props={{
                "href": "https://gitlab.com/StupidHackTH/3/issues/1"
              }}>{`StupidHackTH2 retrospective`}</MDXTag></MDXTag>
          </MDXTag>
          <MDXTag name="li" components={components} parentName="ul">
            <MDXTag name="p" components={components} parentName="li"><MDXTag name="a" components={components} parentName="p" props={{
                "href": "https://gitlab.com/StupidHackTH/3/wikis/StupidHackTH2-Feedback"
              }}>{`StupidHackTH2 feedback survey results`}</MDXTag></MDXTag>
          </MDXTag>
          <MDXTag name="li" components={components} parentName="ul">
            <MDXTag name="p" components={components} parentName="li"><MDXTag name="a" components={components} parentName="p" props={{
                "href": "https://gitlab.com/StupidHackTH/meta/wikis/Event-Coverage"
              }}>{`Event coverage`}</MDXTag>{` (blogs, videos, photos, etc.)`}</MDXTag>
          </MDXTag>
        </MDXTag>
      </section>
           </MDXTag>;
  }

}
MDXContent.isMDXComponent = true;
export const _frontmatter = {};
      